import {Component, OnInit, ViewChild}         from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatPaginator, PageEvent}              from '@angular/material/paginator';
import {MatTableDataSource}                   from '@angular/material/table';
import {UserLookup}                           from '@src/app/admin/users/models/user.model';
import {UsersService}                         from '@src/app/admin/users/services/users.service';
import {ApiService}                           from '@src/app/shared/services/api.service';
import {query}                                from 'js-query-builder';
import {CreditsService}                       from '../../services/credits.service';

@Component({
    selector: 'app-credit-logs',
    templateUrl: './credit-logs.component.html',
    styleUrls: ['./credit-logs.component.scss']
})
export class CreditLogsComponent implements OnInit
{
    @ViewChild(MatPaginator) public paginator!: MatPaginator;
    public displayedColumns: string[] = ['amount', 'change_type', 'transaction_type', 'actioned_by', 'created_at'];
    public credit_logs = new MatTableDataSource<any>([]);
    public totalRows: number = 0;
    public pageSize: number = 30;
    public currentPage: number = 0;
    public pageSizeOptions: number[] = [10, 30, 50, 100];
    public users: UserLookup[];
    public transactionTypes: any[] = [];
    public transactionOrigins: any[] = [];
    public creditLogsFilter: UntypedFormGroup = new UntypedFormGroup({
        amount: new UntypedFormControl(null),
        transaction_origins: new UntypedFormControl(null),
        transaction_types: new UntypedFormControl(null),
        authors: new UntypedFormControl(null)
    });

    public get amountForm(): UntypedFormControl
    {
        return this.creditLogsFilter.controls.amount as UntypedFormControl;
    }

    public get transactionOriginForm(): UntypedFormControl
    {
        return this.creditLogsFilter.controls.transaction_origins as UntypedFormControl;
    }

    public get transactionTypesForm(): UntypedFormControl
    {
        return this.creditLogsFilter.controls.transaction_types as UntypedFormControl;
    }

    public get usersForm(): UntypedFormControl
    {
        return this.creditLogsFilter.controls.authors as UntypedFormControl;
    }

    constructor(
        public apiService: ApiService,
        public usersService: UsersService,
        public creditsService: CreditsService)
    {
        this.credit_logs.data = [];
    }

    public ngOnInit(): void
    {
        this.usersService.list(0, 0, true).subscribe(
            response => this.users = response,
            error => this.apiService.handleError(error)
        );

        this.creditsService.getTransactionTypes().subscribe(
            response => this.transactionTypes = response.data,
            error => this.apiService.handleError(error)
        );

        this.creditsService.getTransactionOrigins().subscribe(
            response => this.transactionOrigins = response.data,
            error => this.apiService.handleError(error)
        );

        this.loadCreditLogs();
    }

    public pageChanged(event: PageEvent): void
    {
        this.pageSize = event.pageSize;
        this.currentPage = event.pageIndex;

        this.loadCreditLogs();
    }

    public loadCreditLogs(): void
    {
        const url = query('credits/logs')
            .fields({
                credit_logs: ['id', 'credit_id', 'amount', 'transaction_origin_id', 'transaction_type_id', 'description', 'author_id', 'created_at']
            })
            .include(['origin', 'type', 'creditable', 'author'])
            .param('page[number]', this?.currentPage + 1)
            .param('page[size]', this?.pageSize)
            .sort('-created_at');

        if (this.amountForm.value != null && this.amountForm.value.length != 0 && this.amountForm.value.length != '') {
            url.filter('amount', this.amountForm.value);
        }

        if (this.transactionOriginForm.value != null && this.transactionOriginForm.value.length > 0) {
            url.filter('transaction_origin_id', this.transactionOriginForm.value);
        }

        if (this.transactionTypesForm.value != null && this.transactionTypesForm.value.length > 0) {
            url.filter('transaction_type_id', this.transactionTypesForm.value);
        }

        if (this.usersForm.value != null && this.usersForm.value.length > 0) {
            url.filter('author_id', this.usersForm.value);
        }

        this.apiService.get(url.build()).subscribe(
            response => {
                this.paginator.pageIndex = this.currentPage;
                this.paginator.length = response.meta.total;
                this.credit_logs.data = response.data;
            },
            error => this.apiService.handleError(error)
        );
    }

}
